import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Sparkles, Circle, ArrowRight } from "lucide-react";
import { SMART_QUIZ } from "@/data/abcContent";
import { useState } from "react";

export default function SmartQuizStep({ onDone }) {
  const [answers, setAnswers] = useState({});
  const allAnswered = Object.keys(answers).length === SMART_QUIZ.questions.length;
  const submit = () => {
    const score = SMART_QUIZ.questions.reduce((s, q) => s + (answers[q.id] === q.correct ? 1 : 0), 0);
    onDone({ answers, score });
  };
  return (
    <div>
      <h2 className="text-2xl sm:text-3xl font-bold text-[var(--ha-text)]">{SMART_QUIZ.title}</h2>
      <p className="mt-3 text-[var(--ha-muted)] leading-relaxed">Responde estas 3 preguntas de repaso.</p>
      <div className="mt-8 space-y-5">
        {SMART_QUIZ.questions.map((q) => (
          <Card key={q.id} className="rounded-2xl border-[var(--ha-border)] bg-white">
            <CardContent className="p-5 sm:p-6">
              <p className="font-semibold text-[var(--ha-text)] leading-snug">{q.text}</p>
              <div className="mt-4 grid grid-cols-1 gap-2">
                {q.options.map((o) => {
                  const chosen = answers[q.id];
                  const isSelected = chosen === o.key;
                  const isCorrect = o.key === q.correct;
                  const showFeedback = chosen !== undefined;
                  return (
                    <button
                      key={o.key}
                      data-testid={`smartquiz-${q.id}-${o.key}`}
                      onClick={() => setAnswers({ ...answers, [q.id]: o.key })}
                      className={`text-left rounded-xl border px-4 py-3 flex items-start gap-3 transition-colors ${
                        showFeedback && isSelected && isCorrect
                          ? "border-[var(--ha-success)] bg-[var(--ha-success)]/10"
                          : showFeedback && isSelected && !isCorrect
                          ? "border-[var(--ha-error)] bg-[var(--ha-error)]/10"
                          : "border-[var(--ha-border)] hover:bg-[var(--ha-bg)]"
                      }`}
                    >
                      <span className={`h-6 w-6 rounded-full border grid place-items-center text-xs font-bold shrink-0 ${
                        isSelected ? "border-[var(--ha-primary)] text-[var(--ha-primary)] bg-white" : "border-[var(--ha-border)] text-[var(--ha-muted)]"
                      }`}>{o.key}</span>
                      <span className="text-sm text-[var(--ha-text)] leading-relaxed">{o.text}</span>
                    </button>
                  );
                })}
              </div>
              {answers[q.id] !== undefined && (
                <p className="mt-3 text-sm text-[var(--ha-muted)]">
                  {answers[q.id] === q.correct ? "Respuesta correcta." : `La respuesta correcta es ${q.correct}.`}
                </p>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
      <div className="mt-8 flex justify-end">
        <Button
          data-testid="smart-quiz-continue-btn"
          onClick={submit}
          disabled={!allAnswered}
          className="rounded-full bg-[var(--ha-primary)] hover:bg-[var(--ha-primary-hover)] text-white h-11 px-6"
        >
          Continuar <ArrowRight className="w-4 h-4 ml-1.5" strokeWidth={1.75} />
        </Button>
      </div>
    </div>
  );
}
